var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"file",attrs:{"type":"file"},on:{"change":_vm.handleFileUpload}}),_c('button',{on:{"click":_vm.submitFile}},[_vm._v("Upload")])])
}
var staticRenderFns = []

export { render, staticRenderFns }